import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React from "react";
import EventAccordion from "./EventAccordion";
interface Props {
  gamePoint: any;
}

export default function GamePointEventList({ gamePoint }: Props) {
  if (!gamePoint) return null;
  const pulling = Array.isArray(gamePoint.pullingTeamEvents)
    ? gamePoint.pullingTeamEvents
    : [];
  const receiving = Array.isArray(gamePoint.receivingTeamEvents)
    ? gamePoint.receivingTeamEvents
    : [];

  return (
    <Box sx={{ mt: 2, display: "flex", gap: 2 }}>
      <Box sx={{ flex: 1 }}>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          Pulling Team Events ({pulling.length})
        </Typography>
        {pulling.map((ev: any, idx: number) => (
          <EventAccordion key={idx} ev={ev} idx={idx} />
        ))}
      </Box>
      <Box sx={{ flex: 1 }}>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          Receiving Team Events ({receiving.length})
        </Typography>
        {receiving.map((ev: any, idx: number) => (
          <EventAccordion key={idx} ev={ev} idx={idx} />
        ))}
      </Box>
    </Box>
  );
}
